




































import Vue from 'vue'
import { Route } from 'vue-router'
import myHeader from '@/components/desktop-header.vue'
import myFooter from '@/components/desktop-footer.vue'
import pagename from '@/components/desktop-pagename.vue'
// import TsWrapper from '@/utils/typesquare'
// const Ts = new TsWrapper()

interface NewsItem {
  date: string
  title: string
  url?: string
  blank?: boolean
}

export default Vue.extend({
  components: { myHeader, myFooter, pagename },
  data() {
    return {
      transitionName: '',
      isHome: true,
      newsList: [
        {
          date: '2026.10.19',
          title: '福岡県立「小倉高校」の歴史的資料整備「明陵アーカイブズ事業」が始動',
          url: 'https://kokura.fku.ed.jp/wp-content/uploads/kokura/2026/10/17150158/R8%E6%98%8E%E9%99%B5%E3%82%A2%E3%83%BC%E3%82%AB%E3%82%A4%E3%83%96%E3%82%BA%E4%BA%8B%E6%A5%AD.pdf',
          blank: true
        },
        {
          date: '2026.10.15',
          title: '那珂市「THE BOTANICAL RESORT 林音」で植物マーケット「森のボタニカル・ギャザリング」10月24日・25日開催',
          url: 'https://hontoyutari.com/botanical/',
          blank: true
        }
      ] as NewsItem[]
    }
  },
  
  // methods: {
  //   beforeEnter() {
  //     Ts.loadFont()
  //   }
  // },

  created() {
    this.isHome = this.$route.name === 'home' ? true : false
  },

  watch: {
    $route(to: Route, from: Route) {
      if (to.name !== 'home') {
        this.transitionName = from.meta.pid < to.meta.pid ? 'slide-next' : 'slide-prev'
        this.isHome = false
      } else {
        this.isHome = true
      }
    }
  }
})
